export default {
  data() {
    return {
      pageNumber: 1,
      sizeperpage: 10,
      maxVisibleButtons: 3,
      searchQuery: "",
      sortKey: "",
      sortOrders: {},
    };
  },
  methods: {
    onPageSelect() {
      const emitKey = this.customEmitKey || "pageChange";
      if (this.searchQuery) {
        this.$emit("doSearch", this.params, this.searchQuery);
      } else this.$emit(emitKey, this.params);
    },
    handlePageChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.onPageSelect();
    },
    nextPage() {
      if (this.pageNumber < this.pageCount) {
        this.pageNumber++;
        this.onPageSelect();
      }
    },
    prevPage() {
      if (this.pageNumber > 1) {
        this.pageNumber--;
        this.onPageSelect();
      }
    },
    sortBy(key) {
      console.log(key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1 || 1;
    },
    goToFirstPage() {
      this.pageNumber = 1;
      this.onPageSelect();
    },
    goToLastPage() {
      this.pageNumber = this.pageCount;
      this.onPageSelect();
    },
    debouncedSearch: (function () {
      // Declare a timer variable to store the setTimeout return value
      let timer = null;

      // Return a function that will be called after the specified delay
      return function () {
        // Clear the previous timer
        clearTimeout(timer);

        // Start a new timer to call the search function after the specified delay
        timer = setTimeout(() => {
          // Send search request to the server
          // Update searchResults with the response
          this.doSearch();
        }, 500);
      };
    })(),
    doSearch() {
      this.pageNumber = 1;
      this.onPageSelect();
    },
    onchange({ target: { value } }) {
      this.sizeperpage = +value;
    },
    handleSearch({ target: { value } }) {
      this.searchQuery = value;
    },
  },
  created() {
    let sortOrders = {};
    const columns = this.tableColumns || [];
    columns.forEach(function (key) {
      sortOrders[key[1]] = 1;
    });
    this.sortOrders = sortOrders;
  },
  computed: {
    currentPage() {
      return this.paginationMeta?.currentPage || this.pageNumber;
    },
    pageCount() {
      return this.paginationMeta?.totalPages;
    },
    totalItems() {
      return this.paginationMeta.totalItems;
    },
    params() {
      return {
        limit: this.sizeperpage,
        page: this.pageNumber,
      };
    },
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 2;
      }
      // When on the last page
      if (this.currentPage === this.pageCount) {
        return this.pageCount - this.maxVisibleButtons;
      }
      // When in between
      return this.currentPage - 1;
    },
    pages() {
      const range = [];

      if (this.startPage === 1) {
        for (
          let i = this.startPage + 1;
          i <=
          Math.min(this.startPage + this.maxVisibleButtons - 1, this.pageCount);
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      } else if (
        this.startPage ===
        this.pageCount - this.maxVisibleButtons + 1
      ) {
        for (
          let i = this.startPage;
          i <=
          Math.min(
            this.startPage + this.maxVisibleButtons - 1,
            this.pageCount - 1
          );
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      } else {
        for (
          let i = this.startPage;
          i <=
          Math.min(this.startPage + this.maxVisibleButtons - 1, this.pageCount);
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      }

      return range;
    },
    paginatedData() {
      let data = this.dataTable;
      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;

      if (sortKey) {
        data = data.slice().sort((a, b) => {
          let valueA = a[sortKey];
          let valueB = b[sortKey];

          console.log(valueA, valueB, 'valueA, valueB');
          if (!isNaN(valueA) && !isNaN(valueB)) {
            // Sort numbers
            return (parseFloat(valueA) - parseFloat(valueB)) * order;
          }

          if (Date.parse(valueA) && Date.parse(valueB)) {
            // Sort dates
            return (new Date(valueA) - new Date(valueB)) * order;
          }

          // Sort strings
          return valueA.localeCompare(valueB) * order;
        });
      }
      return data;
    },
  },
  watch: {
    paginatedData: {
      handler() {
        if (this.paginatedData.length === 0) {
          this.dataCheck = false;
        } else this.dataCheck = true;
      },
    },
    sizeperpage() {
      this.pageNumber = 1;
      const emitKey = this.customEmitKey || "pageChange";
      this.$emit(emitKey, this.params);
    },

    searchQuery() {
      // Call the debouncedSearch method
      this.debouncedSearch();
    },
  },
};
